module.exports = __webpack_public_path__ + "media/application/images/images/thatGuy-da8f8b325a9eb5d6ed9ea19eafd8a5bb.jpg";